module.exports = __webpack_public_path__ + "img/features-img2.1f50f6ef.png";